import React from 'react';
import PDDProjectDashboardHome from "./PDDProjectDashboardHome"
import { pddRoot } from "../../../../utils/defaultValues";
import IntlMessages from "../../../../utils/IntlMessages";

const ProjectDashboardRouteConfig = {
	routes: [
		{
    path: `${pddRoot}/project/project-dashboard`,
    exact: true,
    name: <IntlMessages id={"menu.menu.project-dashboard"}/>,
    element: <PDDProjectDashboardHome/>,
    auth: [],
  },
  {
    path: `${pddRoot}/`,
    exact: true,
    name: <IntlMessages id={"menu.project-dashboard"}/>,
    element: <PDDProjectDashboardHome/>,
    auth: [],
  },
  {
    path: `${pddRoot}/project/`,
    exact: true,
    name: <IntlMessages id={"menu.project-dashboard"}/>,
    element: <PDDProjectDashboardHome/>,
    auth: [],
  },
	]
};
export default ProjectDashboardRouteConfig;
